import { FC } from "react";

import { MuiModal, MuiTypography } from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { createProgramSiteCoreKeys } from "../../siteCore/SiteCoreKeys";

interface ManageLocaleWarningProps {
  show: boolean;
  message: string;
  handleCloseModal: () => void;
  onPrimaryButtonClick: () => void;
}

export const ManageLocaleWarning: FC<ManageLocaleWarningProps> = ({
  show,
  message,
  handleCloseModal,
  onPrimaryButtonClick,
}) => {
  const { commonLabels, fetchLabel } = useSiteCore();

  return (
    <MuiModal
      open={show}
      onClose={handleCloseModal}
      title={commonLabels.warning}
      primaryButtonTitle={fetchLabel(
        createProgramSiteCoreKeys.createActivityKey,
        createProgramSiteCoreKeys.updateLocale,
      )}
      secondaryButtonTitle={commonLabels.cancel}
      onPrimaryButtonClick={onPrimaryButtonClick}
      onSecondaryButtonClick={handleCloseModal}
      className="warning-modal-for-locale"
    >
      <MuiTypography variant="h3">{message}</MuiTypography>
    </MuiModal>
  );
};
